import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})

export class UserDataService {
  users:any[]=[];
  token:string=""
  key:string="";
  laguage=true;
  number=-1;

  inventionDetailData:any; //To navigate inside detail component
  private companyName:string="patents"; //Get company name from mail
   attorneyName="";
   ifAttorney=false;
   lookAttorney="";
  error=new BehaviorSubject<string>("");
  //firebaseProjectName:string="https://sisecam-a8421-default-rtdb.firebaseio.com/"; Old Project Directory
  firebaseProjectName:string="https://patent-book-default-rtdb.firebaseio.com/";
  constructor(private route:Router, private http:HttpClient, private auth:AuthService) {
  }
  setCompanyName() {
    this.companyName=this.auth.userMail.split('@')[1].split('.')[0];

    switch(this.auth.userMail) {
      case "umuttuzer@hotmail.com": {this.companyName="sisecam"} break;



      }

  }
  setAttorneyLogin(){
    this.attorneyName=this.auth.userMail.split('@')[0].split('-')[1];
      }
      checkAttorney(){
        this.lookAttorney=(this.auth.userMail.split('@')[0].split('-')[0]);
        console.log(this.lookAttorney);
        if(this.lookAttorney=="vekil"){this.ifAttorney=!this.ifAttorney}
        console.log(this.ifAttorney)
          }


  /*addUser(inventionName:string, inventionDate:string, inventorName:string, inventorShare:string, inventorAdress:string, inventorMail:string, inventorIdentity:string, inventorStatus:string) {
    this.setCompanyName();
    this.token=this.auth.token;
    this.users.push({inventionName,inventionDate,inventorName,inventorShare,inventorAdress,inventorMail,inventorIdentity,inventorStatus});
    this.http.post('https://sisecam-a8421-default-rtdb.firebaseio.com/'+this.companyName+'.json?auth='+this.token, (this.users)).
    subscribe(arr=>console.log(arr),
    err=>{
    this.error=err.statusText;
    console.log(this.error)});
    this.users=[];
    this.route.navigate(["patentList"]);
    }*/
    addUser(CompanyData:any, AttorneyData:any,rdCenter:any, project:any,documentNumber:string, inventionName:string, inventionDate:string, inventorData:any, status:any, docLink:any, patentInfo:any) {
      this.setCompanyName();//Save Invention in a draft status!!!

      this.token=this.auth.token;
      this.users=[]; //WORRRRRKED
      this.users.push({CompanyData,AttorneyData,rdCenter,project,documentNumber,inventionName,inventionDate,inventorData,status,docLink,patentInfo});
      return this.http.post(this.firebaseProjectName+this.companyName+'/inventions.json?auth='+this.token, (this.users))
      /*.
      subscribe(arr=>console.log(arr),
      err=>{
      this.error=err.statusText;
      console.log(this.error)});
      this.users=[];
      this.route.navigate(["patentList"]);*/
      }
      updateInvention(CompanyData:any, AttorneyData:any, rdCenter:any,project:any,documentNumber:string, inventionName:string, inventionDate:string, inventorData:any, status:any,  docLink:any, patentInfo:any, key:string,notes:any) {
        this.setCompanyName();//Save Invention in a draft status!!!
        this.users=[];
        this.token=this.auth.token;
        this.users.push({CompanyData,AttorneyData,rdCenter,project,documentNumber,inventionName,inventionDate,inventorData,status,docLink,patentInfo,notes});
       return this.http.put(this.firebaseProjectName+this.companyName+'/inventions/'+ key +'.json?auth='+this.token, (this.users));
        /*.
        subscribe(arr=>console.log(arr),
        err=>{
        this.error=err.statusText;
        console.log(this.error)});
        this.users=[];*/
        //this.route.navigate(["patentList"]);
        }


    addInventor(inventorName:string,  inventorAdress:string, inventorMail:string, inventorIdentityNo:string, inventorStatus:string, inventorsCompany:any, LoggedUser:any) {
      this.setCompanyName();
      this.users=[];
      this.token=this.auth.token;
     this.users.push({inventorName,inventorAdress,inventorMail,inventorIdentityNo,inventorStatus,inventorsCompany,LoggedUser});
     //console.log(this.users);
      return this.http.post(this.firebaseProjectName+this.companyName+'/inventors.json?auth='+this.token, (this.users));

      }
    addCompany(CompanyName:string,  CompanyAdress:string, CompanyIdentityNo:string, LoggedUser:any) {
      this.setCompanyName();
      this.token=this.auth.token;
      this.users=[];
      this.users.push({CompanyName,CompanyAdress,CompanyIdentityNo,LoggedUser});
      //console.log(this.users);
      return this.http.post(this.firebaseProjectName+this.companyName+'/companies.json?auth='+this.token, ([{CompanyName,CompanyAdress,CompanyIdentityNo,LoggedUser}]));
        }

        addRDCenter(centerName:string, LoggedUser:any) {
          this.setCompanyName();
          this.token=this.auth.token;
          this.users=[];
          this.users.push({centerName,LoggedUser});
          console.log(this.users, this.companyName)
          return this.http.post(this.firebaseProjectName+this.companyName+'/rdCenter.json?auth='+this.token, ([{centerName,LoggedUser}]));
            }
        addAttorney(AttorneyName:string,  AttorneyAdress:string, AttorneyIdentityNo:string, LoggedUser:any) {
          this.setCompanyName();
          this.token=this.auth.token;
          this.users=[];
          this.users.push({AttorneyName,AttorneyAdress,AttorneyIdentityNo,LoggedUser});
          //console.log(this.users);
          return this.http.post(this.firebaseProjectName+this.companyName+'/attornies.json?auth='+this.token, ([{AttorneyName,AttorneyAdress,AttorneyIdentityNo,LoggedUser}]));
            }
            addProject(projectCode:string, projectDetail:string, LoggedUser:any) {
              this.setCompanyName();
              this.token=this.auth.token;
              this.users=[];
              this.users.push({projectCode,projectDetail,LoggedUser});
              console.log(this.users, this.companyName)
              return this.http.post(this.firebaseProjectName+this.companyName+'/projects.json?auth='+this.token, ([{projectCode,projectDetail,LoggedUser}]));
                }
            addOtherJob(recordTitle:string,recordType:string, detail:string,  attorneyName:string, terminationDate:string, LoggedUser:any,status:any) {

              this.setCompanyName();
              this.token=this.auth.token;
              this.users=[];
              this.users.push({recordTitle,recordType,detail,attorneyName, terminationDate, LoggedUser,status});
              //console.log(this.users);
              return this.http.post(this.firebaseProjectName+this.companyName+'/otherJobs.json?auth='+this.token, ([{recordTitle,recordType,detail,attorneyName, terminationDate, LoggedUser,status}]));
                }
                updateJob(key:string, status:string) {
                  this.setCompanyName();
                  this.token=this.auth.token;

                  return this.http.put(this.firebaseProjectName+this.companyName+'/otherJobs/'+ key+'/0/status'+'.json?auth='+this.token, ([status]));
                }
                deleteJob (key:string) { console.log(key);
                  this.setCompanyName();
                  this.token=this.auth.token;

                return  this.http.delete(this.firebaseProjectName+this.companyName +'/otherJobs/'+ key +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));
                }



    deletionRecords(responsiblePerson:any, area:string, detail:string) {
      this.token=this.auth.token;
    return this.http.post(this.firebaseProjectName+this.companyName+'/deletionRecords.json?auth='+this.token, ([{responsiblePerson,area,detail}]));
      }

    fetchInventor(token:string) {
      this.setCompanyName();
      return this.http.get(this.firebaseProjectName+this.companyName+'/inventors.json?auth='+token)
    }
    fetchCompany(token:string) {
      this.setCompanyName();
      return this.http.get(this.firebaseProjectName+this.companyName+'/companies.json?auth='+token)
    }
    fetchRDCenter(token:string) {
      this.setCompanyName();
      return this.http.get(this.firebaseProjectName+this.companyName+'/rdCenter.json?auth='+token)
    }
    fetchProjects(token:string) {
      this.setCompanyName();
      return this.http.get(this.firebaseProjectName+this.companyName+'/projects.json?auth='+token)
    }
    fetchAttorney (token:string) {
      this.setCompanyName();
      return this.http.get(this.firebaseProjectName+this.companyName+'/attornies.json?auth='+token)
    }

    fetchdeletionRecords(token:string) {
      this.setCompanyName();
      return this.http.get(this.firebaseProjectName+this.companyName+'/deletionRecords.json?auth='+token)
    } //Embadded into master data ts
    fetchUsers(token:string) {
    this.setCompanyName();
    return this.http.get(this.firebaseProjectName+this.companyName+'/inventions.json?auth='+token)
  }
  fetchJobs(token:string) {
    this.setCompanyName();
    return this.http.get(this.firebaseProjectName+this.companyName+'/otherJobs.json?auth='+token)
  }

  removeInvention(key:string) {
    this.setCompanyName();
    this.token=this.auth.token;
  return  this.http.delete(this.firebaseProjectName+this.companyName +'/inventions/'+ key +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));
  }
  removeInventor(key:string) {
    this.setCompanyName();
    this.token=this.auth.token;

  return  this.http.delete(this.firebaseProjectName+this.companyName +'/inventors/'+ key +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));
  }
  removeCompany(key:string) {
    this.setCompanyName();
    this.token=this.auth.token;
  return  this.http.delete(this.firebaseProjectName+this.companyName +'/companies/'+ key +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));
  }
  removeAttorney(key:string) {
    this.setCompanyName();
    this.token=this.auth.token;
  return  this.http.delete(this.firebaseProjectName+this.companyName +'/attornies/'+ key +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));
  }
  removeRDCenter(key:string) {
    this.setCompanyName();
    this.token=this.auth.token;
  return  this.http.delete(this.firebaseProjectName+this.companyName +'/rdCenter/'+ key +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));
  }
  removeProject(key:string) {
    this.setCompanyName();
    this.token=this.auth.token;
  return  this.http.delete(this.firebaseProjectName+this.companyName +'/projects/'+ key +'.json?auth='+this.token).subscribe(res=>{console.log(res)},err=> this.error=(err.statusText));
  }


  getKey (key:string) {
    this.token=this.auth.token;
    this.setCompanyName();
   // console.log(key, this.token);
    this.key=key;
  //  console.log(this.key);
    return this.key;
    /*return this.http.get('https://sisecam-a8421-default-rtdb.firebaseio.com/'+this.companyName +'/'+ key +'.json?auth='+this.token)*/
  }
  getItemNumber(i:number) {this.number=i;
                          console.log(this.number)}

  inventionDetail(key:string) {
    return this.http.get(this.firebaseProjectName+this.companyName +'/inventions/'+ key +'.json?auth='+this.token)
  }


}
